@if (isActive()) {
    <div class="inner-page-wrapper">
        <div class="mb-2 mt-8">
            <button class="-ml-8 flex items-center" (click)="back()">
                <i class="icon-chevron-left text-24 text-accent"></i>
                <span class="text-center text-16 font-medium text-accent">zurück</span>
            </button>
        </div>
        <form class="mx-auto mb-24 max-w-[792px] md:mb-40" [formGroup]="form">
            <h1 class="leading-29 text-24 md:text-center md:text-34 md:leading-41">Ihre Daten</h1>
            <p class="text-14">Pflichtfelder sind mit * gekennzeichnet</p>
            <div class="mb-12 mt-16">
                <ui-input-radio
                    [options]="[
                        { label: 'Frau', value: GENDER.FEMALE },
                        { label: 'Herr', value: GENDER.MALE },
                        { label: 'Divers', value: GENDER.DIVERS },
                    ]"
                    [formControl]="form.controls.gender"
                />
            </div>
            <div class="grid grid-cols-1 gap-x-56 gap-y-12 md:grid-cols-2">
                @let firstNameCtr = form.controls.firstName;
                <ui-input-text
                    [formControl]="firstNameCtr"
                    [error]="firstNameCtr.touched && firstNameCtr.invalid"
                    [errorMsg]="getErrorMessage(firstNameCtr)"
                    label="Vorname *"
                />
                @let lastNameCtr = form.controls.lastName;
                <ui-input-text
                    [formControl]="lastNameCtr"
                    [error]="lastNameCtr.touched && lastNameCtr.invalid"
                    [errorMsg]="getErrorMessage(lastNameCtr)"
                    label="Nachname *"
                />
            </div>
            <div class="mt-12 md:mt-[20px]">
                <ui-input-checkbox [formControl]="form.controls.businessCustomer">
                    Ich bin Firmenkunde
                </ui-input-checkbox>
            </div>

            <ui-m040-c030-badge class="mb-8 mt-24 block lg:mt-32" [type]="'blue'">EXPRESS</ui-m040-c030-badge>
            <ui-m040-c140-tabs
                [options]="[
                    {
                        value: SERVICECONTACTTABS.PHONE,
                        label: 'Wir rufen Sie zur Terminfindung an',
                        visible: true,
                    },
                    {
                        value: SERVICECONTACTTABS.EMAIL,
                        label: 'Wir senden Ihnen per Email Terminvorschläge',
                        visible: true,
                    },
                ]"
                [control]="form.controls.tab"
            />

            @if (form.controls.tab.value === SERVICECONTACTTABS.PHONE) {
                <div
                    class="relative z-10 grid animate-show grid-cols-1 gap-x-56 gap-y-12 bg-grey-100 px-24 py-20 lg:grid-cols-2 lg:px-12 lg:py-24"
                >
                    @if (dealers().length > 1) {
                        @let dealerCtr = form.controls.dealer;
                        <ui-input-select
                            [formControl]="dealerCtr"
                            [options]="dealers()"
                            [error]="dealerCtr.touched && dealerCtr.invalid"
                            [errorMsg]="getErrorMessage(dealerCtr)"
                            label="Händler *"
                        />
                    }
                    @let phoneNumberCtr = form.controls.phoneNumber;
                    <ui-input-text
                        [formControl]="phoneNumberCtr"
                        [error]="phoneNumberCtr.touched && phoneNumberCtr.invalid"
                        [errorMsg]="getErrorMessage(phoneNumberCtr)"
                        label="Telefonnummer *"
                    />
                    @let contactTimeCtr = form.controls.contactTime;
                    <ui-input-select
                        [formControl]="contactTimeCtr"
                        [options]="[
                            {
                                label: 'Vormittags',
                                value: 'Vormittags',
                            },
                            {
                                label: 'Nachmittags',
                                value: 'Nachmittags',
                            },
                        ]"
                        [error]="contactTimeCtr.touched && contactTimeCtr.invalid"
                        [errorMsg]="getErrorMessage(contactTimeCtr)"
                        label="Wann sind Sie am besten erreichbar? *"
                    />
                </div>
            } @else {
                <div
                    class="relative z-10 grid animate-show grid-cols-1 gap-x-56 gap-y-24 bg-grey-100 px-24 py-20 lg:grid-cols-2 lg:px-12 lg:py-24"
                >
                    <div class="flex flex-col gap-12 lg:pt-[37px]">
                        @if (dealers().length > 1) {
                            @let dealerCtr = form.controls.dealer;
                            <ui-input-select
                                [formControl]="form.controls.dealer"
                                [options]="dealers()"
                                [error]="dealerCtr.touched && dealerCtr.invalid"
                                [errorMsg]="getErrorMessage(dealerCtr)"
                                label="Händler *"
                            />
                        }
                        @let emailCtr = form.controls.email;
                        <ui-input-text
                            [formControl]="emailCtr"
                            [error]="emailCtr.touched && emailCtr.invalid"
                            [errorMsg]="getErrorMessage(emailCtr)"
                            label="Email-Adresse *"
                            type="email"
                        />

                        <ui-input-textarea
                            [label]="'Ihre Nachricht'"
                            [formControl]="form.controls.message"
                            [defaultHeight]="195"
                            label="Ihre Nachricht"
                            placeholder=""
                        />
                    </div>
                    <div class="flex flex-col gap-12">
                        <p class="font-headline text-20 font-medium leading-25">Ihr Hyundai</p>
                        @if (servicesFormContent(); as serviceForm) {
                            @let modelCtr = form.controls.model;
                            <ui-input-select
                                [formControl]="modelCtr"
                                [options]="serviceForm.models"
                                [error]="modelCtr.touched && modelCtr.invalid"
                                [errorMsg]="getErrorMessage(modelCtr)"
                                label="Modell *"
                            />
                        }
                        @let numberplateCtr = form.controls.numberplate;
                        <ui-input-text
                            [formControl]="numberplateCtr"
                            [error]="numberplateCtr.touched && numberplateCtr.invalid"
                            [errorMsg]="getErrorMessage(numberplateCtr)"
                            label="Kennzeichen *"
                        />
                        @let mileageCtr = form.controls.mileage;
                        <ui-input-text
                            [formControl]="mileageCtr"
                            [error]="mileageCtr.touched && mileageCtr.invalid"
                            [errorMsg]="getErrorMessage(mileageCtr)"
                            label="Km-Stand *"
                        />
                        @let firstRegCtr = form.controls.firstReg;
                        <ui-input-text
                            [formControl]="firstRegCtr"
                            [error]="firstRegCtr.touched && firstRegCtr.invalid"
                            [errorMsg]="getErrorMessage(firstRegCtr)"
                            label="Erstzulassung *"
                        />
                    </div>
                </div>
            }

            <div
                class="frc-captcha my-12 md:my-[20px]"
                #frccaptcha
                data-sitekey="FCMGC0V4K1N4MFFN"
                data-puzzle-endpoint="https://api.friendlycaptcha.com/api/v1/puzzle"
            ></div>

            <div class="flex flex-col items-end gap-24">
                <div class="border-grey-300 text-14 lg:border-t lg:pt-24">
                    <p>
                        {{ disclaimer }}
                        <a [hyundaiRouterLink]="dealer().pages.privacy" target="_blank">
                            https://hyundai-partners{{ dealer().pages.privacy }}
                        </a>
                    </p>
                </div>
                <button class="button-primary lg:max-w-[292px]" [disabled]="form.invalid" (click)="next()">
                    Absenden
                </button>
            </div>
        </form>
    </div>
}
